export { default } from './GetYourNFTSection'